// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1axDV","col":"CardReaderDesc_col__3dNUj","label":"CardReaderDesc_label__8VpSM"};